module.exports = __webpack_public_path__ + "static/media/hogar-card.58d6ffe5.svg";